module.exports = __webpack_public_path__ + "img/build-in-2020-3.780bca25.jpg";